import React, { Component } from 'react';
import { connect } from 'react-redux';
import './Rooms.css';
import Tabbar from '../../Components/Tabbar/Tabbar';
import RoomsPageComponent from '../../Components/Pages/RoomsPageComponent';
import PageFilter from '../../Components/Pages/PageFilter';
import RoomTypesModal from '../../Components/Modals/RoomTypesModal';
import RoomDetailTypesModal from '../../Components/Modals/RoomDetailTypesModal';
import './Rooms.css';
import SuccessModal from '../../Components/successModal';
import SecondarySuccessModal from '../../Components/secondarySuccessModal';
import TertiarySuccessModal from '../../Components/tertiarySuccessModal';

// actions
// import { roomFetchData, roomDeleteData } from '../../Store/Actions/RoomActions';
import { getAll, add, del, getRooms,  edit, clearSuccess, clearSecondarySuccess, clearTertiarySuccess } from '../../Store/Actions/RestActions';

class RoomsPage extends Component {

	componentDidMount() {
		this.props.roomFetch();
		this.props.roomTypeFetch();
		this.props.resourceTypeFetch();
		this.props.roomDetailTypesFetch();
		this.props.buildingsFetch();
		this.props.floorsFetch();
		this.props.assetsFetch();
	}

	render() {
		return (
			<div>
				<div className="container roomsIndex">
					<Tabbar setActiveTab="rooms" />
					<div className="contentBox tabbed-content-box no-padding">
						<PageFilter {...this.props}>
							<RoomsPageComponent />
						</PageFilter>
						<div className="gear-container">
							<RoomTypesModal items={this.props.roomTypes} handleSubmit={this.props.addRoomType} handleEdit={this.props.editRoomType} {...this.props} handleDeleteClick={this.props.deleteRoomType} />
							<RoomDetailTypesModal items={this.props.roomDetailTypes} handleSubmit={this.props.addRoomDetail} handleEdit={this.props.editRoomDetail} handleDeleteClick={this.props.deleteRoomDetailType}{...this.props} />
						</div>
					</div>

				</div>
				<SuccessModal success={this.props.success} successMsg="Room action completed successfully" onClose={this.props.clearSuccess}></SuccessModal>												
				<SecondarySuccessModal success={this.props.roomTypesSuccess} successMsg="Room Type action completed successfully" onClose={this.props.clearSecondarySuccess}></SecondarySuccessModal>												
				<TertiarySuccessModal success={this.props.roomDetailTypesSuccess} successMsg="Room Detail Type action completed successfully" onClose={this.props.clearTertiarySuccess}></TertiarySuccessModal>												
			</div>
		);
	}
}
const mapStateToProps = state => ({
	rooms: state.rooms.data,
	buildings: state.buildings.data,
	floors: state.floors.data,
	roomTypes: state.roomTypes.data,
	roomDetailTypes: state.roomDetailTypes.data,
	assets: state.assets.data,
	filterData: state.rooms.data,
	success: state.rooms.success,
	roomTypesSuccess: state.roomTypes.success,
	roomDetailTypesSuccess: state.roomDetailTypes.success
	
});

const mapDispatchtoProps = dispatch => ({
	addClick: data => dispatch(add('rooms', data)),
	addRoomDetail: data => dispatch(add('roomdetailtypes', data)),
	editRoomDetail: data => dispatch(edit('roomdetailtypes', data, data.id)),
	addRoomType: data => dispatch(add('roomtypes', data)),
	editRoomType: data => dispatch(edit('roomtypes', data, data.id)),
	roomFetch: () => dispatch(getRooms()),
	roomTypeFetch: () => dispatch(getAll('roomtypes', {})),
	roomDetailTypesFetch: () => dispatch(getAll('roomdetailtypes', {})),
	resourceTypeFetch: () => dispatch(getAll('assetdetailtypes', {})),
	assetsFetch: () => dispatch(getAll('assets', {})),
	buildingsFetch: () => dispatch(getAll('buildings', {})),
	floorsFetch: () => dispatch(getAll('floors', {})),
	deleteClick: id => dispatch(del('rooms', {}, id)),
	deleteRoomDetailType: id => dispatch(del('roomdetailtypes', {}, id)),
	deleteRoomType: id => dispatch(del('roomtypes', {}, id)),
	clearSuccess: () => dispatch(clearSuccess('rooms')),
	clearSecondarySuccess: () => dispatch(clearSecondarySuccess('roomTypes')),	
	clearTertiarySuccess: () => dispatch(clearTertiarySuccess('roomDetailTypes'))		
});

export default connect(mapStateToProps, mapDispatchtoProps)(RoomsPage);


// WEBPACK FOOTER //
// ./src/Pages/Rooms/Rooms.js